import React, { FC, useLayoutEffect, useRef } from 'react';

import { useContainerWidth } from '../../../../util/responsiveness';
import { useMeasureContainerWidth } from '../../../../util/responsiveness/useMeasureContainerWidth';
import { shouldRenderContentSidebarAtWidth, useContentContainerContext } from '../../hooks';

import { getClassNames } from './QuickNavContainer.styles.legacy';

const QuickNavContainer: FC = ({ children }) => {
  const quickNavQueryDivRef = useRef<HTMLDivElement>(null);
  const quickNavContainerWidth = useMeasureContainerWidth(quickNavQueryDivRef);
  const containerWidth = useContainerWidth();
  const isPanelPinned = shouldRenderContentSidebarAtWidth(containerWidth);
  const classNames = getClassNames(isPanelPinned);
  const { onQuickNavWidthChanged } = useContentContainerContext();

  useLayoutEffect(() => {
    if (quickNavContainerWidth) {
      onQuickNavWidthChanged(quickNavContainerWidth);
    }
  }, [quickNavContainerWidth, onQuickNavWidthChanged]);

  return (
    <div className={classNames.quickNavContainer}>
      <div className={classNames.inner}>{children}</div>
      <div ref={quickNavQueryDivRef} />
    </div>
  );
};

export default QuickNavContainer;
